import styled from "styled-components";

import FlexBox from "../../common/FlexBox";
import { H1 } from "../../common/Headings";
import { DAVYS_GREY_100 } from "../../common/colors";

const Container = styled(FlexBox)`
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  border-radius: 3rem;
  background-color: #78909c;
  justify-content: center;
  align-items: center;
`;

const AccountAvatar = ({ name }) => {
  return (
    <Container>
      <H1 bold color={DAVYS_GREY_100}>
        {name?.[0]}
      </H1>
    </Container>
  );
};

export default AccountAvatar;
